import * as React from 'react';
import { formatAsDollars, percentage } from '../../../../lib/helpers';

import styles from '../../../../styles/sass/pages/Tools.module.scss';

export interface Props {
  data: any[];
}

export const calculatePricePointerText = (data: any[]): any => {
  const firstMonth = data[0];
  const lastMonth = data[data.length - 1];

  const zip = firstMonth.zipCode;
  const town = firstMonth.town;
  const medianListPrice = formatAsDollars(lastMonth.medianListPrice);
  const medianSalePrice = formatAsDollars(lastMonth.medianSalePrice);
  const avgPriceDelta = percentage(Math.abs(lastMonth.avgPriceDelta));
  const deltaVerb = lastMonth.avgPriceDelta >= 0 ? 'more' : 'less';
  const yoyFlux = percentage(Math.abs(lastMonth.yoyFlux));
  const fluxVerb = lastMonth.yoyFlux >= 0 ? 'more' : 'less';
  const avgDelta = percentage(firstMonth.trendAvg);
  const avgDeltaNoun = firstMonth.trendAvg >= 0 ? 'premium' : 'discount';

  if (
    !medianListPrice ||
    !medianSalePrice ||
    !avgPriceDelta ||
    !avgPriceDelta
  ) {
    return false;
  }

  return {
    zip,
    town,
    avgPriceDelta,
    deltaVerb,
    yoyFlux,
    fluxVerb,
    avgDelta,
    avgDeltaNoun,
  };
};

const PricePointerText = (props: Props) => {
  const { data } = props;
  const {
    zip,
    town,
    avgPriceDelta,
    deltaVerb,
    yoyFlux,
    fluxVerb,
    avgDelta,
    avgDeltaNoun,
  } = calculatePricePointerText(data);
  return (
    <p className={styles.trendText}>
      Last month, buyers paid an average of{' '}
      <strong>
        {avgPriceDelta} {deltaVerb}
      </strong>{' '}
      in {zip} ({town}) than sellers were asking.
      <br />
      That&#39;s{' '}
      <strong>
        {yoyFlux} {fluxVerb}
      </strong>{' '}
      than a year ago.
      <br />
      The average {avgDeltaNoun} throughout the year was{' '}
      <strong>{avgDelta}</strong>.
    </p>
  );
};

export default PricePointerText;
